import { environmentHttpClient } from "client/Api/httpClient";
import { HubItemKind } from "../hubItemCategories";
import { HubItemMediaPreviewViewModel } from "../common";
import { HubItemLayoutDetailsViewModel, HubItemMediaDetailsViewModel } from "../common.details";

export type HubTemplateListItemModel = {
	id: number;
	name: string;
	media: HubItemMediaPreviewViewModel;
};

export type HubTemplateListModel = {
	items: readonly HubTemplateListItemModel[];
	canManageTemplates: boolean;
};

export function list(kind: HubItemKind, signal: AbortSignal): Promise<HubTemplateListModel> {
	return environmentHttpClient.get<HubTemplateListModel>(
		"UiApi/Hub/Templates",
		{ kind },
		{ signal }
	);
}

export type HubTemplateDetailsViewModel = {
	id: number;
	kind: HubItemKind;
	title: string;
	layout: HubItemLayoutDetailsViewModel;
	media: HubItemMediaDetailsViewModel;
};

export function preview(id: number, signal: AbortSignal): Promise<HubTemplateDetailsViewModel> {
	return environmentHttpClient.get<HubTemplateDetailsViewModel>(
		`UiApi/Hub/Templates/${id}/Preview`,
		undefined,
		{ signal }
	);
}
